/* USE PROTECTION design: the product lists - behaviour of sections/up-collection.liquid, up-search-results.liquid and
   up-rail.liquid (cards: snippets/up-card.liquid). Loaded deferred by each of those sections; runs once per page.

   GRIDS ([data-u-grid] + [data-u-more]): the server renders the first cards, the rest of its page waits in
   <template data-u-queue>, and further cards come from the cards-only endpoints (?view=up-cards&page=N:
   templates/collection.up-cards.liquid, templates/search.up-cards.liquid; 250 products a request). "Incarca mai
   multe" asks for the next <per> VISIBLE cards: the gender lens hides the other face's cards with a pre-paint CSS
   rule (html.mf-g-women .u-card[data-g="m"] ...), so a card counts only when window.__mfGShow passes it.
   One design, one card - across loads too: the key is the card's data-mark (the design name), plus the product
   handle on the Monogram letter view (one card per letter there), as the live mfKeepFirstDesign.

   INFINITE SCROLL (owner 2026-10-25): every grid loads on its own as the visitor nears its end - the load-more row
   is watched with an IntersectionObserver reaching AUTO_AHEAD px below the screen, so the next <per> cards are laid
   out about two phone screens early, and their images are switched to eager right away (native lazy loading would
   wait until they are close). The queue is kept PREFETCH batches ahead: once fewer visible cards wait than that, the
   next cards page (or newest page for the weave) is asked in the background, so a scroll mostly lays out cards that
   are already here. The button stays as the fallback: a browser without IntersectionObserver, a failed page (no
   auto-asking until the button retries) and keyboard users. Step <stepName>_auto (cbar:more_auto / search:more_auto)
   once per grid and pageview; the clicks keep cbar:more / search:more.

   A first page the exclusions emptied still fetches onward; 6 pages that bring nothing visible end the search
   (the live auto-fill's limit) and the empty state [data-u-cempty] shows.

   THE NEWEST WEAVE (the live collection-ab-alternate section, data-weave on the collection): in the collection's
   default order, when that default is best-selling, one of the newest designs goes after every N visible cards
   (live: 2 - base, base, newest, ...). The newest cards come from ?view=up-weave&sort_by=created-descending
   (templates/collection.up-weave.liquid, 48 products a request); the server's first cards are laid out again
   once enough have arrived. Woven cards carry data-ab-alternate="true", as live.

   THE COLLECTION ORDER (owner 2026-10-25; the arm is window.__mfRank, dealt by snippets/mf-rank-head): on a grid the
   section marks data-u-rank-ok (the collection's own best-selling order, page 1, not the Monogram view, not a
   blacklisted collection) arms c and d replace the server's cards with their own order before anything shows (the
   section's inline script hid them: data-u-rank-wait):
     c  newest first - the cards endpoint with sort_by=created-descending, page by page as load more asks
     d  random       - every cards page at once (at most RANK_PAGES), one shuffle over all of them keyed on the visit's
                       seed and the design key, so back / forward, an in-place re-render and load more never reshuffle
   Both play without the newest weave. Arm b is the server order with the weave (unchanged); a is not built yet and
   plays as b. A failed first request leaves the server's cards (window.__mfRank.played = false).

   THE THIN FACE (mf-face.js's strip, which only knows collection-v2's grid): when the active face leaves fewer than
   8 cards (12 with a mood on) and hid some, the .mf-thin strip goes above the grid with "Vezi tot" (face off);
   plp:g_thin once per result set, at most 3 a page view; the button sends mnu:g_off + mnu:g_offstrip, as live.

   RAILS ([data-u-rail]): topped up from the collection's cards endpoint while fewer than data-u-limit cards are
   visible under the active face (the live ajax-collection's face top-up).

   CARD CLICKS: a list card is an arbitrary pick, never an exact variant choice - stamped as sessionStorage
   mf_cardpin, the contract of mf-device.js 1d that snippets/mf-device-head's guard 17 reads (a case-type chip puts
   ?variant= on the links), so the remembered-phone hop still happens.

   COLLECTION BAR ([data-u-coll]): the lens calls window.__mfSetFace and announces mf:face-changed (source 'clist');
   the case-type chips, the sort and the mood squares re-render the section in place through the Section Rendering
   API (same URL + section_id) and push the URL, so every state is a real, shareable address; back / forward
   re-render from the address. On a mood collection the moods are collections: plain navigation.

   The device sheet opened from the heading (data-up-src="coll"): assets/up-menu.js carries the sort and the filters and
   sends cbar:dev_go, as live collection-v2; here the Monogram letter is added to the row's href.

   THE MONOGRAM VIEW (owner 2026-10-21, the live collection-v2 view pill + letter row in this design):
     - the bar's Monogram pill: off the view it opens the Monogram sheet (window.mfOpenMonogram, assets/up-mono.js) on
       the page's phone (data-mono-base; the visitor's phone where the page is not a device), cbar:view_<key> as the
       live pill; without the sheet it navigates to the view. On the view it is pressed and leaves it: the view's tags
       (data-mono-tags, handles) and the letter come out of the address, in-place re-render, cbar:view_all.
     - the letter row ([data-u-letters]) on the view: one letter at a time, the grid keeps that letter's cases
       (mfMonoLetter(data-mark, data-mono), snippets/mf-l10n.liquid - "A II" is Á, digraphs are letters, the
       "Series - A 2.0 - device" titles give theirs through data-mono). The letter lives in the address (?letter=A,
       replaceState), so the view with a letter is a link: the sheet's "Vezi toate monogramele" lands on it, back /
       forward and the other bar controls keep it. The row is A-Z as the sheet's tiles; the catalogue's own letters
       (Á É Ö Ü CS GY NY SZ ZS) are in it hidden and show only while chosen (a ?letter=CS link). No "Toate": a second
       tap on the pressed letter clears it (and the empty state's "Vezi toate literele"). Every cards page of the
       view is asked at once (data-u-par), right away with a letter, else once the page has loaded; then a letter
       with no design under the lens is greyed out. While a letter's pages load, skeleton tiles hold the grid's
       place (a ?letter= link: from before the first paint, the server's unfiltered cards out of the layout). A
       failed page is not "every page in": nothing is greyed or called empty on its account; the load-more button
       retries it. A re-laid card is the same node (marks of promo22 / mf-track stay on it). Steps
       cbar:letter_<x>_pick / cbar:letter_all_pick (á/é/ö/ü as a2/e2/o2/u2), the live row's keys; a letter from the
       address sends none, as the live restore.
     - the sheet's CTA for this very page's path re-renders the view in place instead of a page load (up-mono.js
       marks it data-action then, so mf-track does not count a plp:to_plp that never navigates).

   Measurement: mf_nav_step through window.mfTrackPush, the cbar:* family of the live collection bar
   (dev_open, dev_go, g_<face>, mood_<key> / mood_off, view_new / view_best / view_all for the sort, type_full /
   type_pro / type_off, more, view_<key> / view_all for the Monogram pill, letter_<x>_pick / letter_all_pick),
   search:more, plp:g_thin. ES5 on purpose (no build step). */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.__upLists) { return; }
  W.__upLists = true;

  function step(name) {
    try { if (W.mfTrackPush) { W.mfTrackPush('mf_nav_step', { mf_step: String(name).toLowerCase().replace(/[^a-z0-9_:]/g, '_').slice(0, 40) }); } } catch (e) {}
  }
  function href(p) { return W.mfHref ? W.mfHref(p) : p; }
  function shows(el) {
    if (el.hasAttribute('hidden')) { return false; }
    return W.__mfGShow ? W.__mfGShow(el) : true;
  }
  function isCard(el) { return el && el.nodeType === 1 && el.classList && el.classList.contains('u-card'); }
  /* the page is being left (pagehide): its cancelled card fetches are not failures. Back from the bfcache, a list
     whose pages failed asks again. */
  var leaving = false;
  W.addEventListener('pagehide', function () { leaving = true; });
  W.addEventListener('pageshow', function (e) {
    leaving = false;
    if (!e.persisted) { return; }
    [].forEach.call(D.querySelectorAll('[data-u-more]'), function (m) { var l = m.__upList; if (l && l.failed) { l.failed = false; fill(l); } });
  });

  /* ---- the design key ---- */
  function cardKey(card, mono) {
    var k = (card.getAttribute('data-mark') || '').trim().toLowerCase();
    if (k && mono) {
      /* a "Series - A 2.0 - device" title: its letter part (snippets/up-card mono), the endpoint's own key */
      var m = (card.getAttribute('data-mono') || '').trim().toLowerCase();
      if (m) { return k + ' - ' + m; }
      var h = (card.getAttribute('href') || '').split('?')[0].split('/').pop() || '';
      k += ' - ' + h.replace(/-(iphone|samsung|galaxy|huawei|xiaomi|redmi|poco|oneplus|honor|pixel|google|oppo|realme|nothing|apple|s\d{2}|a\d{2})[-a-z0-9]*$/i, '');
    }
    return k;
  }
  function seenOf(list) {
    if (!list.seen) {
      list.seen = {};
      var cards = list.grid.querySelectorAll('.u-card');
      for (var i = 0; i < cards.length; i++) { var k = cardKey(cards[i], list.mono); if (k) { list.seen[k] = 1; } }
    }
    return list.seen;
  }
  function keepFirst(list, card) {
    var k = cardKey(card, list.mono);
    if (!k) { return true; }
    var s = seenOf(list);
    if (s[k]) { return false; }
    s[k] = 1;
    return true;
  }
  function visibleCount(root) {
    var n = 0, cards = root.querySelectorAll('.u-card');
    for (var i = 0; i < cards.length; i++) { if (shows(cards[i])) { n++; } }
    return n;
  }

  /* ---- the endpoint ---- */
  function endpointUrl(src, page, view, sort) {
    var path = src || location.pathname;
    var q = path.indexOf('?') >= 0 ? path.split('?')[1] : location.search.replace(/^\?/, '');
    path = path.split('?')[0];
    var params = new URLSearchParams(q);
    params.delete('page');
    params.delete('section_id');
    params.delete('letter');   /* the Monogram letter filters on this side; one cached endpoint URL per view */
    params.set('view', view || 'up-cards');
    if (sort) { params.set('sort_by', sort); }
    params.set('page', String(page));
    return path + '?' + params.toString();
  }
  function fetchCards(src, page, view, sort) {
    return fetch(endpointUrl(src, page, view, sort), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var meta = doc.getElementById('up-cards-meta');
        return {
          cards: [].slice.call(doc.querySelectorAll('a.u-card')),
          pages: meta ? (parseInt(meta.getAttribute('data-pages'), 10) || 0) : 0,
          mixed: !!meta && meta.getAttribute('data-mixed') === '1'
        };
      });
  }

  /* ---- GRIDS ---- */
  function initGrid(more) {
    if (more.__upList) { return more.__upList; }
    var root = more.closest('[data-u-coll], [data-u-srch]') || more.parentNode;
    var grid = root.querySelector('[data-u-grid]');
    if (!grid) { return null; }
    var tpl = root.querySelector('template[data-u-queue]');
    var rank = rankOf(root);
    var list = {
      root: root, grid: grid, more: more,
      mono: root.hasAttribute('data-mono'),
      per: parseInt(more.getAttribute('data-u-per'), 10) || 24,
      src: more.getAttribute('data-u-src') || '',
      pages: parseInt(more.getAttribute('data-u-pages'), 10) || 0,
      par: parseInt(more.getAttribute('data-u-par'), 10) || 1,
      next: 1, loading: false, seen: null, dry: 0, mixed: false,
      queue: tpl && tpl.content ? [].slice.call(tpl.content.children).filter(isCard) : [],
      stepName: more.getAttribute('data-u-step') || 'cbar:more',
      empty: root.querySelector('[data-u-cempty]'),
      weave: rank ? null : weaveOf(root),
      rank: rank,
      thin: null, thinX: false, thinStep: false,
      sk: grid.querySelector('.u-sk'),   /* the Monogram view's skeleton tiles: cards are laid in before them */
      failed: false,                     /* a cards page failed: no auto-asking, the button retries */
      auto: false, io: null, autoStep: false   /* INFINITE SCROLL: the load-more row is within AUTO_AHEAD */
    };
    list.target = Math.max(list.per, visibleCount(grid));
    more.__upList = list;
    if (list.mono) { monoInit(list); }
    initAuto(list);
    rkWatchGrid(list);
    fill(list);
    if (list.letter) { revealPressed(list.letters); }
    if (list.letters && !list.letter) { afterLoad(function () { if (!list.loading && !list.failed && list.next <= list.pages) { ask(list, 'b'); } }); }
    return list;
  }
  function afterLoad(fn) {
    var go = function () { setTimeout(fn, 600); };
    if (D.readyState === 'complete') { go(); } else { W.addEventListener('load', go); }
  }

  /* ---- THE MONOGRAM VIEW: the letter filter ---- */
  function letterOf(card) {
    return W.mfMonoLetter ? W.mfMonoLetter(card.getAttribute('data-mark') || '', card.getAttribute('data-mono') || '') : '';
  }
  function normLetter(v) { return W.mfNormLetter ? W.mfNormLetter(v) : String(v || '').trim().toUpperCase(); }
  function urlLetter() {
    var v = '';
    try { v = new URLSearchParams(location.search).get('letter') || ''; } catch (e) { v = ''; }
    return v ? normLetter(v) : '';
  }
  function letterStep(l) { return l ? l.toLowerCase().replace(/á/g, 'a2').replace(/é/g, 'e2').replace(/ö/g, 'o2').replace(/ü/g, 'u2') : 'all'; }
  function matches(list, card) { return !list.letter || letterOf(card) === list.letter; }
  /* every card of the view known so far, one per design and letter, in the collection's order (a card already laid
     out once stands for itself: place() keeps its node on the parsed one) */
  function monoAll(list) {
    var seen = {}, out = [];
    for (var i = 0; i < list.all.length; i++) {
      var c = list.all[i].__upLive || list.all[i], k = cardKey(c, true);
      if (k && seen[k]) { continue; }
      if (k) { seen[k] = 1; }
      out.push(c);
    }
    return out;
  }
  function monoInit(list) {
    list.all = [].slice.call(list.grid.children).filter(isCard).concat(list.queue);
    list.letters = list.root.querySelector('[data-u-letters]');
    list.lstat = list.root.querySelector('[data-u-lstat]');
    list.lempty = list.root.querySelector('[data-u-lempty]');
    list.letter = list.letters ? urlLetter() : '';
    if (list.letter) { relayLetter(list); }
    list.root.classList.remove('u-lpend');   /* the pre-paint cover of a letter in the address (up-collection) */
  }
  /* the grid laid out again for the letter: its cards out, the queue = the known cards of that letter */
  function relayLetter(list) {
    var cards = [].slice.call(list.grid.children).filter(isCard);
    for (var i = 0; i < cards.length; i++) { list.grid.removeChild(cards[i]); }
    list.seen = null;
    list.queue = monoAll(list).filter(function (c) { return matches(list, c); });
    list.target = list.per;
    list.dry = 0;
    list.thinX = false;
  }
  function addCards(list, cards) {
    if (!list.all) { list.queue = list.queue.concat(cards); return; }
    list.all = list.all.concat(cards);
    list.queue = list.queue.concat(cards.filter(function (c) { return matches(list, c); }));
  }
  function setLetter(list, l, via) {
    l = l ? normLetter(l) : '';
    if (l === list.letter) { return; }
    list.letter = l;
    step('cbar:letter_' + letterStep(l) + (via ? '_' + via : ''));
    relayLetter(list);
    try {
      var u = new URL(location.href);
      if (l) { u.searchParams.set('letter', l); } else { u.searchParams.delete('letter'); }
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      lastUrl = location.pathname + location.search;
    } catch (e) {}
    /* pages in flight: fill() would wait for them with an empty grid - lay out the letter's known cards now, the
       skeletons stand in for the rest */
    if (list.loading) { take(list); paint(list); } else { fill(list); }
    revealPressed(list.letters);
  }
  function revealPressed(row) {
    var on = row && row.querySelector('[aria-pressed="true"]');
    if (!on || row.scrollWidth <= row.clientWidth) { return; }
    var r = on.getBoundingClientRect(), m = row.getBoundingClientRect();
    if (r.left >= m.left && r.right <= m.right) { return; }
    row.scrollLeft += (r.left - m.left) - (m.width - r.width) / 2;
  }
  /* the row: the pressed letter; the chosen letter's tile when it is not A-Z (the catalogue's own letters are in the
     row, hidden unless chosen; any other letter gets a tile once a design shows it exists - a made-up ?letter= gets
     none, only the empty state); a letter with nothing under the lens greyed out once every page is in. The grid:
     skeleton tiles while a letter's pages load, the empty state when it has nothing. The screen-reader status; the
     "din N" of the count line. */
  function paintLetters(list) {
    var row = list.letters;
    if (!row) { return; }
    var done = list.next > list.pages && !list.loading && !list.failed;
    var cards = monoAll(list), has = {}, n = {}, i, l;
    for (i = 0; i < cards.length; i++) {
      l = letterOf(cards[i]);
      if (!l) { continue; }
      has[l] = 1;
      if (shows(cards[i])) { n[l] = (n[l] || 0) + 1; }
    }
    var tiles = row.querySelectorAll('[data-u-letter]'), found = false;
    for (i = 0; i < tiles.length; i++) {
      var x0 = tiles[i].getAttribute('data-u-letter');
      if (x0 === list.letter) { found = true; }
      if (!tiles[i].hasAttribute('data-u-x')) { continue; }
      if (tiles[i].getAttribute('data-u-x') === 'dyn' && x0 !== list.letter) { row.removeChild(tiles[i]); continue; }
      tiles[i].hidden = x0 !== list.letter;
    }
    if (list.letter && !found && has[list.letter]) {
      var nb = D.createElement('button'), sp = D.createElement('span');
      nb.type = 'button';
      nb.setAttribute('data-u-letter', list.letter);
      nb.setAttribute('data-u-x', 'dyn');
      if (list.letter.length > 1) { nb.setAttribute('data-wide', ''); }
      sp.textContent = list.letter;
      nb.appendChild(sp);
      row.appendChild(nb);
      revealPressed(row);
    }
    [].forEach.call(row.querySelectorAll('[data-u-letter]'), function (b) {
      var x = b.getAttribute('data-u-letter');
      b.setAttribute('aria-pressed', x === list.letter ? 'true' : 'false');
      b.disabled = done && !n[x] && x !== list.letter;
    });
    var vis = visibleCount(list.grid);
    /* skeletons: a letter's designs are spread over every page, so until they are in, the known ones and the
       skeletons fill three rows on a phone, two from 760px (the bar, the grid and the footer stay where they are).
       Skeleton i stands in slot i: with k cards laid in before them, the first k are off, so no skeleton moves to
       another slot when a card arrives (a moved tile is a layout shift; one that goes is not) */
    var cap = W.matchMedia && W.matchMedia('(min-width: 760px)').matches ? 8 : 6;
    var busy = !!list.letter && list.loading;
    var sks = list.grid.querySelectorAll('.u-sk');
    for (i = 0; i < sks.length; i++) { if (busy && i >= vis && i < cap) { sks[i].setAttribute('data-on', ''); } else { sks[i].removeAttribute('data-on'); } }
    list.grid.setAttribute('aria-busy', busy && vis < cap ? 'true' : 'false');
    var none = !!list.letter && done && !vis;
    if (list.lempty) {
      list.lempty.hidden = !none;
      var big = list.lempty.querySelector('[data-u-lempty-l]');
      if (big) { big.textContent = list.letter; }
    }
    var msg = !list.letter ? '' : list.loading ? T('mono.loading') : none ? T('mono.empty') : '';
    if (list.lstat && list.lstat.textContent !== msg) { list.lstat.textContent = msg; }
    var tot = list.more.querySelector('[data-u-total]');
    if (tot) {
      if (!tot.hasAttribute('data-n')) { tot.setAttribute('data-n', tot.textContent); }
      tot.textContent = !list.letter ? tot.getAttribute('data-n') : done ? String(cards.filter(function (c) { return matches(list, c); }).length) : '…';
    }
  }

  /* ---- ARM A: what the collection grids show and what is taken from them (every arm; mf-beacon api/plp.js) ----
     A card that is half on screen for a second counts once per pageview: its design (data-mark) and its depth band
     (its place among the grid's visible cards: 1-8 / 9-24 / 25-48 / 49-96 / 97+), sent in batches of 20 and when the
     page is left (sendBeacon, text/plain). A tap sends the design and band at once and leaves them in sessionStorage
     mf_rka, so the product page it opens can send the add (assets/up-pdp.js). Collection grids only (not search, not
     rails), and only where the store has a beacon (window.__mfStore.beacon_url). The scores come back from
     api/rank.js, read by arm A below. */
  var RKB = (function () {
    var st = W.__mfStore || {}, u = String(st.beacon_url || '');
    if (!/\/api\/case-add/.test(u)) { return null; }
    var base = u.replace(/\/api\/case-add.*$/, '');
    return { plp: base + '/api/plp', rank: base + '/api/rank', c: String(st.beacon_c || ''), cc: String(st.cc || '') };
  })();
  /* the beacon's design key (mf-beacon lib/rank.js rankKey): lower case, ' glossy' out, its slug */
  function rkKey(raw) {
    var v = String(raw || '').toLowerCase().replace(/\s+glossy\b/g, '').replace(/\s+/g, ' ').trim();
    return v.slice(0, 24).replace(/[^A-Za-z0-9 ._-]/g, '').replace(/\s+/g, '_');
  }
  function rkBand(pos) { return pos <= 8 ? 1 : pos <= 24 ? 2 : pos <= 48 ? 3 : pos <= 96 ? 4 : 5; }
  function rkPos(card) {
    var g = card.parentNode, n = 0;
    if (!g) { return 0; }
    for (var i = 0; i < g.children.length; i++) {
      var c = g.children[i];
      if (!isCard(c) || !shows(c)) { continue; }
      n++;
      if (c === card) { return n; }
    }
    return 0;
  }
  var rkQ = [], rkSeen = {}, rkIO = null, rkT = (typeof WeakMap === 'function') ? new WeakMap() : null;
  function rkSend(body) {
    if (!RKB) { return; }
    body.c = RKB.c;
    try { if (W.navigator && W.navigator.sendBeacon) { W.navigator.sendBeacon(RKB.plp, JSON.stringify(body)); } } catch (e) {}
  }
  function rkFlush() { if (rkQ.length) { rkSend({ imp: rkQ.splice(0, 120) }); } }
  function rkWatch(card) {
    if (!RKB || !rkIO || !card || card.__rkW) { return; }
    card.__rkW = true;
    rkIO.observe(card);
  }
  if (RKB && typeof W.IntersectionObserver === 'function' && rkT) {
    rkIO = new W.IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var card = en.target;
        if (en.isIntersecting) {
          if (rkT.get(card)) { return; }
          rkT.set(card, setTimeout(function () {
            rkT.delete(card);
            if (!card.isConnected || !shows(card)) { return; }
            var m = card.getAttribute('data-mark') || '';
            var k = rkKey(m);
            if (!k || rkSeen[k]) { return; }
            var pos = rkPos(card);
            if (!pos) { return; }
            rkSeen[k] = 1;
            rkQ.push([m, rkBand(pos)]);
            if (rkQ.length >= 20) { rkFlush(); }
            rkIO.unobserve(card);
          }, 1000));
        } else if (rkT.get(card)) { clearTimeout(rkT.get(card)); rkT.delete(card); }
      });
    }, { threshold: 0.5 });
    W.addEventListener('pagehide', rkFlush);
    D.addEventListener('visibilitychange', function () { if (D.visibilityState === 'hidden') { rkFlush(); } });
  }
  function rkWatchGrid(list) {
    if (!rkIO || !list.root.hasAttribute('data-u-coll')) { return; }
    [].forEach.call(list.grid.children, function (c) { if (isCard(c)) { rkWatch(c); } });
  }
  function rkClick(card) {
    if (!RKB) { return; }
    var m = card.getAttribute('data-mark') || '', pos = rkPos(card);
    if (!rkKey(m) || !pos) { return; }
    var b = rkBand(pos);
    rkFlush();
    rkSend({ clk: [m, b] });
    var hm = /^\/products\/([^\/?#]+)/.exec(W.mfPath ? W.mfPath(card.pathname || '') : (card.pathname || ''));
    try { W.sessionStorage.setItem('mf_rka', JSON.stringify({ m: m, b: b, h: hm ? decodeURIComponent(hm[1]) : '', t: new Date().getTime() })); } catch (eR) {}
  }

  /* ---- THE COLLECTION ORDER (snippets/mf-rank-head) ---- */
  var RANK_PAGES = 8;   /* cards pages (of 250) arm d shuffles at once; a longer collection's later pages come shuffled per page */
  function rankOf(root) {
    if (!root || !root.hasAttribute('data-u-rank-ok')) { return null; }
    var r = W.__mfRank || {};
    if (r.arm !== 'c' && r.arm !== 'd' && r.arm !== 'a') { return null; }
    try { if (new URLSearchParams(location.search).get('sort_by')) { return null; } } catch (e) { return null; }
    return { arm: r.arm, seed: r.seed || 1, pages: parseInt(root.getAttribute('data-u-rank-pages'), 10) || 1, ready: false };
  }
  function rankSort(list) { return list.rank && list.rank.arm === 'c' ? 'created-descending' : ''; }
  /* FNV-1a: the shuffle key of a design for this visit - a pure function of (seed, design), so the order is the same
     whichever page a card arrived on */
  function fnv(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return h >>> 0;
  }
  function rankShuffle(list, cards, force) {
    if (!list.rank || (list.rank.arm !== 'd' && !force)) { return cards; }
    var seed = String(list.rank.seed);
    var keyed = cards.map(function (c, i) { return { c: c, k: fnv(seed + '|' + (cardKey(c, list.mono) || '#' + i)) }; });
    keyed.sort(function (x, y) { return x.k - y.k; });
    return keyed.map(function (x) { return x.c; });
  }
  function rankUnwait(list) { list.root.removeAttribute('data-u-rank-wait'); }
  /* ARM A (owner 2026-10-25): the design scores (mf-beacon api/rank.js, recomputed after the store's midnight: 50 is
     average, a design it has not seen is new = 50 + 15) rank two slots in three; every third slot is an EXPLORE slot - a
     design with fewer than 1500 impressions, drawn for this visit with a weight that falls as its impressions grow
     (the exponential-key draw u^(1/w), u from the visit's seed and the design), so new and little-seen designs keep
     getting shown wherever the ranking would bury them. Ties keep the server's best-selling order; no scores (a failed
     request, a store without a beacon) = every design 65, i.e. the best-selling order with the explore slots. */
  var RK_EXPLORE = 3, RK_NEW = 65, RK_FULL = 1500;
  /* the newness bonus (owner 2026-10-31, "Újdonság bónusz: legyen így" - the newest-first arm C won RO): a design's card
     gets up to RK_BORN_PTS on top of its score on the day its product was created (data-born, snippets/up-card),
     falling to 0 over RK_BORN_DAYS days */
  var RK_BORN_PTS = 20, RK_BORN_DAYS = 21;
  function rkBorn(c) {
    var t = parseInt(c.getAttribute('data-born'), 10);
    if (!(t > 0)) { return 0; }
    var age = (Date.now() / 1000 - t) / 86400;
    return age < 0 ? RK_BORN_PTS : RK_BORN_PTS * Math.max(0, 1 - age / RK_BORN_DAYS);
  }
  function rankA(list, cards, sc) {
    var S = (sc && sc.s) || {}, seed = String(list.rank.seed), seenA = {}, info = [];
    cards.forEach(function (c, i) {
      var k0 = cardKey(c, list.mono);
      if (k0) { if (seenA[k0]) { return; } seenA[k0] = 1; }
      var k = rkKey(c.getAttribute('data-mark') || ''), e = S[k];
      info.push({ c: c, i: i, s: (e ? Number(e[0]) || RK_NEW : RK_NEW) + rkBorn(c), imp: e ? Number(e[1]) || 0 : 0, k: k || ('#' + i) });
    });
    var ranked = info.slice().sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); });
    var cand = info.filter(function (x) { return x.imp < RK_FULL; }).map(function (x) {
      var u = (fnv(seed + '|x|' + x.k) + 1) / 4294967297, w = Math.max(0.05, 1 - x.imp / RK_FULL);
      return { x: x, r: Math.pow(u, 1 / w) };
    }).sort(function (a, b) { return b.r - a.r; }).map(function (o) { return o.x; });
    var used = {}, out = [], ri = 0, ci = 0, slot = 0, pick;
    var nextR = function () { while (ri < ranked.length && used[ranked[ri].i]) { ri++; } return ri < ranked.length ? ranked[ri++] : null; };
    var nextC = function () { while (ci < cand.length && used[cand[ci].i]) { ci++; } return ci < cand.length ? cand[ci++] : null; };
    while (out.length < info.length) {
      slot++;
      pick = (slot % RK_EXPLORE === 0 ? nextC() : null) || nextR() || nextC();
      if (!pick) { break; }
      used[pick.i] = 1;
      if (slot % RK_EXPLORE === 0) { pick.c.setAttribute('data-rk-x', '1'); }
      out.push(pick.c);
    }
    return out;
  }
  /* the design scores (owner 2026-10-31, Black Friday traffic): first from Shopify itself (templates/index.mf-rank.liquid,
     the shop metafield mf-beacon writes nightly), then the beacon's /api/rank; each ask gives up after RK_ASK_MS, so the
     grid never waits on a slow server (null = the server's order) */
  var RK_ASK_MS = 1500;
  function rankAsk(url, opts) {
    return new Promise(function (res) {
      var t = setTimeout(function () { res(null); }, RK_ASK_MS);
      W.fetch(url, opts).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { clearTimeout(t); res(d && d.s ? d : null); }, function () { clearTimeout(t); res(null); });
    });
  }
  function rankScores() {
    if (!RKB || !RKB.cc || !W.fetch) { return Promise.resolve(null); }
    var root = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    return rankAsk(root + '?view=mf-rank', { credentials: 'same-origin' }).then(function (d) {
      /* a copy older than three days (the nightly sync stopped) gives way to the beacon's fresh one */
      if (d && !(Date.parse(d.day) > Date.now() - 3 * 864e5)) { d = null; }
      return d || rankAsk(RKB.rank + '?cc=' + encodeURIComponent(RKB.cc), { credentials: 'omit' });
    });
  }
  /* the first layout of a re-ordering arm: its first page(s) replace the server's cards (grid and queue) */
  function rankStart(list) {
    var rk = list.rank, n = (rk.arm === 'd' || rk.arm === 'a') ? Math.min(rk.pages, RANK_PAGES) : 1, asks = [];
    list.loading = true;
    paint(list);
    for (var p = 1; p <= n; p++) { asks.push(fetchCards(list.src, p, null, rankSort(list))); }
    if (rk.arm === 'a') { asks.push(rankScores()); }
    Promise.all(asks).then(function (all) {
      var sc = rk.arm === 'a' ? all.pop() : null;
      list.loading = false;
      rk.ready = true;
      var cards = [];
      for (var i = 0; i < all.length; i++) {
        cards = cards.concat(all[i].cards);
        if (all[i].mixed) { list.mixed = true; }
      }
      list.pages = Math.max(all[0].pages || 0, rk.pages);
      list.next = n + 1;
      [].slice.call(list.grid.children).filter(isCard).forEach(function (c) { list.grid.removeChild(c); });
      /* owner 2026-10-31: arm A without its scores (Shopify and the beacon both failed) plays the random order (d) */
      if (rk.arm === 'a' && !sc) { W.__mfRank.fb = 'd'; }
      list.queue = rk.arm === 'a' && sc ? rankA(list, cards, sc) : rankShuffle(list, cards, rk.arm === 'a');
      list.seen = null;
      list.dry = 0;
      W.__mfRank.played = true;
      fill(list);
      rankUnwait(list);
    }, function (err) {
      list.loading = false;
      rk.ready = true;
      W.__mfRank.played = false;   /* the server's best-selling cards stay: assets/mf-track.js leaves this view out */
      fill(list);
      rankUnwait(list);
      if (!leaving && !(err && err.name === 'AbortError') && W.console) { console.error('up-lists: collection order failed', err); }
    });
  }

  /* ---- THE NEWEST WEAVE (collection-ab-alternate) ---- */
  var WEAVE_CAP = 8;   /* newest pages (of 48) a grid may ask for */
  function weaveOf(root) {
    var every = parseInt(root.getAttribute('data-weave'), 10) || 0;
    if (!every || !root.hasAttribute('data-u-coll')) { return null; }
    /* live isBestSellingActive: the default order only - a sort the visitor picked stays a pure ranking */
    if (root.getAttribute('data-default-sort') !== 'best-selling') { return null; }
    try { if (new URLSearchParams(location.search).get('sort_by')) { return null; } } catch (e) { return null; }
    return { every: every, queue: [], next: 1, pages: 1, on: true, started: false, need: false, run: 0 };
  }
  function wovenUsable(list) {
    var s = seenOf(list), n = 0, q = list.weave.queue;
    for (var i = 0; i < q.length; i++) { var k = cardKey(q[i], list.mono); if (!(k && s[k]) && shows(q[i])) { n++; } }
    return n;
  }
  function canAskWeave(w) { return w.next <= w.pages && w.next <= WEAVE_CAP; }
  /* the next newest card that is neither on screen already nor hidden by the face; null when the queue ran dry */
  function nextWoven(list) {
    var q = list.weave.queue;
    while (q.length) {
      var c = q.shift();
      var k = cardKey(c, list.mono);
      if (k && seenOf(list)[k]) { continue; }
      if (!shows(c)) { continue; }
      if (!keepFirst(list, c)) { continue; }
      return c;
    }
    return null;
  }
  /* the weave arrived: the server's cards go back to the front of the queue and are laid out again with it */
  function relayout(list) {
    var cards = [].slice.call(list.grid.children).filter(isCard);
    for (var i = 0; i < cards.length; i++) { list.grid.removeChild(cards[i]); }
    list.queue = cards.concat(list.queue);
    list.seen = null;
    list.weave.run = 0;
  }
  function place(list, node, woven) {
    var placed = placeNode(list, node, woven);
    if (list.root.hasAttribute('data-u-coll')) { rkWatch(placed); }
    return placed;
  }
  function placeNode(list, node, woven) {
    var el = node.ownerDocument === D ? node : (node.__upLive || D.importNode(node, true));
    if (el !== node) { node.__upLive = el; }   /* laid out again later (Monogram letter): the same node */
    if (woven) { el.setAttribute('data-ab-alternate', 'true'); }
    list.grid.insertBefore(el, list.sk && list.sk.parentNode === list.grid ? list.sk : null);
    return el;
  }
  /* drop queued cards whose design is already on screen or queued earlier, so the button and the count never
     promise duplicates (the 250-product pages repeat designs across phone models) */
  function prune(list) {
    var s = seenOf(list), q = {}, out = [];
    for (var i = 0; i < list.queue.length; i++) {
      var k = cardKey(list.queue[i], list.mono);
      if (k && (s[k] || q[k])) { continue; }
      if (k) { q[k] = 1; }
      out.push(list.queue[i]);
    }
    list.queue = out;
  }
  function hasMore(list) {
    for (var i = 0; i < list.queue.length; i++) { if (shows(list.queue[i])) { return true; } }
    return list.next <= list.pages;
  }
  function paint(list) {
    prune(list);
    var shown = list.more.querySelector('[data-u-shown]');
    if (shown) { shown.textContent = String(visibleCount(list.grid)); }
    /* the search count line: exact once every page is in ("14"), "N+" while more may come */
    var dn = list.root.querySelector('[data-u-designs]');
    if (dn && !list.loading) {
      var n = list.grid.querySelectorAll('.u-card').length + list.queue.length;
      dn.textContent = n + (list.next <= list.pages ? '+' : '');
    }
    var both = list.root.querySelector('[data-u-both]');
    if (both && list.mixed) { both.hidden = true; }
    var btn = list.more.querySelector('[data-u-more-btn]');
    if (btn) { btn.disabled = list.loading; btn.setAttribute('aria-busy', list.loading ? 'true' : 'false'); }
    list.more.hidden = (!list.loading && !hasMore(list)) || (!!list.letter && list.loading);
    if (list.empty) { list.empty.hidden = list.loading || !!list.grid.querySelector('.u-card'); }
    paintLetters(list);
    checkThin(list);
    /* the row is still near the screen after a layout (short batch, tall screen): go on, a tick later */
    if (list.auto && !list.loading && !list.autoQ) { list.autoQ = setTimeout(function () { list.autoQ = 0; autoMore(list); }, 0); }
  }

  /* ---- INFINITE SCROLL ---- */
  var AUTO_AHEAD = 1600;   /* px below the screen at which the next batch is laid out */
  var PREFETCH = 2;        /* batches of <per> visible cards kept waiting in the queue */
  function initAuto(list) {
    if (list.io || typeof W.IntersectionObserver !== 'function') { return; }
    list.io = new W.IntersectionObserver(function (entries) {
      list.auto = !!entries[entries.length - 1].isIntersecting;
      if (list.auto) { autoMore(list); }
    }, { rootMargin: '0px 0px ' + AUTO_AHEAD + 'px 0px' });
    list.io.observe(list.more);
  }
  function autoMore(list) {
    if (!list.auto || list.loading || list.failed || list.more.hidden || !list.more.isConnected || !hasMore(list)) { return; }
    if (list.rank && !list.rank.ready) { return; }
    /* the observer's flag lags one frame behind a layout: ask the geometry, so a batch is never laid out twice */
    if (list.more.getBoundingClientRect().top - (W.innerHeight || D.documentElement.clientHeight) > AUTO_AHEAD) { list.auto = false; return; }
    if (!list.autoStep) { list.autoStep = true; step(list.stepName + '_auto'); }
    var before = list.grid.querySelectorAll('.u-card').length;
    list.target = visibleCount(list.grid) + list.per;
    fill(list);
    /* the batch laid out now sits up to AUTO_AHEAD below the screen: fetch its images now, not when they come close */
    var cards = list.grid.querySelectorAll('.u-card');
    for (var i = before; i < cards.length; i++) {
      var imgs = cards[i].querySelectorAll('img[loading="lazy"]');
      for (var j = 0; j < imgs.length; j++) { imgs[j].loading = 'eager'; }
    }
  }
  /* keep PREFETCH batches waiting: ask the next page in the background while the queue runs low */
  function prefetch(list) {
    if (list.loading || list.failed || (list.rank && !list.rank.ready)) { return; }
    var need = list.per * PREFETCH, w = list.weave;
    if (w && w.on && w.started && canAskWeave(w) && wovenUsable(list) * (w.every + 1) < need) { ask(list, 'w'); return; }
    if (list.next > list.pages) { return; }
    var n = 0;
    for (var i = 0; i < list.queue.length && n < need; i++) { if (shows(list.queue[i])) { n++; } }
    if (n < need) { ask(list, 'b'); }
  }

  /* ---- THE THIN FACE: the escape strip (mf-face.js 2, for this grid) ---- */
  var thinSteps = 0;
  /* the store words (snippets/mf-l10n.liquid, the kit keys mono.* / face.*); no built-in fallback: a missing key is an
     empty string, never another store's language */
  function T(k) { return W.mfT ? W.mfT(k) : ''; }
  function dropThin(list) { if (list.thin && list.thin.parentNode) { list.thin.parentNode.removeChild(list.thin); } list.thin = null; }
  function checkThin(list) {
    if (!list.root.hasAttribute('data-u-coll')) { return; }
    /* a Monogram letter is a short list by choice; the row's greyed letters say what the lens leaves */
    if (!face() || list.letter) { dropThin(list); return; }
    if (list.loading) { return; }   /* judged once the grid has settled */
    var shown = visibleCount(list.grid), all = list.grid.querySelectorAll('.u-card').length;
    var floor = (/[?&]filter\.p\.tag=/.test(location.search) || list.root.querySelector('.u-moodc [aria-current="true"]')) ? 12 : 8;
    /* nothing hidden by the face: a short grid is not a thin FACE */
    if (shown >= floor || shown === all) { dropThin(list); return; }
    if (list.thinX || list.thin) { return; }
    if (!list.thinStep && thinSteps < 3) { thinSteps++; step('plp:g_thin'); }
    list.thinStep = true;
    var bar = D.createElement('div');
    bar.className = 'mf-thin';
    bar.setAttribute('role', 'status');
    var txt = D.createElement('span');
    txt.className = 'mf-thin__txt';
    txt.textContent = T('face.thin');
    var go = D.createElement('button');
    go.type = 'button';
    go.className = 'mf-thin__cta';
    go.setAttribute('data-u-thin', 'all');
    go.textContent = T('face.show_all');
    var x = D.createElement('button');
    x.type = 'button';
    x.className = 'mf-thin__x';
    x.setAttribute('data-u-thin', 'x');
    x.setAttribute('aria-label', T('face.close'));
    x.textContent = '\u2715';
    bar.appendChild(txt);
    bar.appendChild(go);
    bar.appendChild(x);
    list.grid.parentNode.insertBefore(bar, list.grid);
    list.thin = bar;
  }
  function take(list) {
    var added = 0, w = list.weave;
    while (visibleCount(list.grid) < list.target) {
      if (w && w.on && w.started && w.run >= w.every) {
        var wc = nextWoven(list);
        if (wc) { place(list, wc, true); w.run = 0; added++; continue; }
        if (canAskWeave(w)) { w.need = true; break; }   /* fill() asks for the next newest page */
        w.on = false;                                    /* the newest ran out: plain order from here */
      }
      if (!list.queue.length) { break; }
      var node = list.queue.shift();
      if (!keepFirst(list, node)) { continue; }
      var el = place(list, node, false);
      added++;
      if (w && w.on && w.started && shows(el)) { w.run++; }
    }
    return added;
  }
  var DRY_CAP = 6;      /* pages in a row that bring nothing visible: stop (the live auto-fill's limit) */
  function fill(list) {
    if (list.loading) { return; }
    if (list.rank && !list.rank.ready) { rankStart(list); return; }
    var w = list.weave;
    /* the first layout with the weave waits for enough newest cards to fill the screen once, then lays out again */
    if (w && w.on && !w.started) {
      if (wovenUsable(list) < Math.ceil(list.target / (w.every + 1)) && canAskWeave(w)) { ask(list, 'w'); return; }
      w.started = true;
      relayout(list);
    }
    take(list);
    if (visibleCount(list.grid) >= list.target) { paint(list); prefetch(list); return; }
    if (w && w.on && w.need) { ask(list, 'w'); return; }
    if (list.next <= list.pages && !list.failed) { ask(list, 'b'); return; }
    paint(list);
  }
  function ask(list, kind) {
    list.loading = true;
    paint(list);
    var asks = [], w = list.weave, first = list.next;
    if (kind === 'w') {
      w.need = false;
      asks.push(fetchCards(list.src, w.next++, 'up-weave', 'created-descending'));
    } else {
      /* the search grid asks its pages side by side (data-u-par): its 250-result pages repeat the same few designs
         on every phone model, so most come back as duplicates and one round trip beats four */
      while (asks.length < list.par && list.next <= list.pages) { asks.push(fetchCards(list.src, list.next++, null, rankSort(list))); }
    }
    Promise.all(asks).then(function (all) {
      list.loading = false;
      if (kind === 'w') {
        w.pages = all[0].pages;
        w.queue = w.queue.concat(all[0].cards);
        fill(list);
        return;
      }
      for (var i = 0; i < all.length; i++) {
        if (all[i].pages && all[i].pages < list.pages) { list.pages = all[i].pages; }
        if (all[i].mixed) { list.mixed = true; }
        addCards(list, rankShuffle(list, all[i].cards));
      }
      var v0 = visibleCount(list.grid);
      take(list);
      if (visibleCount(list.grid) > v0) { list.dry = 0; }
      else if (!list.queue.length) { list.dry += all.length; if (list.dry >= DRY_CAP) { list.next = list.pages + 1; } }
      fill(list);
    }, function (err) {
      list.loading = false;
      if (kind === 'w') { w.on = false; w.need = false; if (!w.started) { w.started = true; } }
      else {
        /* these pages are not in: they stay to be asked (the button retries, and so does a bfcache return), but
           not on their own - and nothing counts as "every page is in", so no letter is greyed out and no letter
           reads as empty on a page that never arrived */
        list.next = first;
        list.failed = true;
      }
      fill(list);
      /* a page left while its cards were in flight cancels them: not an error */
      if (!leaving && !(err && err.name === 'AbortError') && W.console) { console.error('up-lists: load more failed', err); }
    });
  }
  function initGrids(scope) {
    [].forEach.call((scope || D).querySelectorAll('[data-u-more]'), initGrid);
  }

  /* ---- RAILS: the face top-up ---- */
  function topRail(rail) {
    if (rail.__upBusy || rail.__upDone) { return; }
    var limit = parseInt(rail.getAttribute('data-u-limit'), 10) || 12;
    if (visibleCount(rail) >= limit) { return; }
    var list = rail.__upList || (rail.__upList = { grid: rail, mono: false, seen: null });
    var add = function (cards) {
      for (var i = 0; i < cards.length && visibleCount(rail) < limit; i++) {
        if (!shows(cards[i]) || !keepFirst(list, cards[i])) { continue; }
        rail.appendChild(D.importNode(cards[i], true));
      }
    };
    if (rail.__upPool) { add(rail.__upPool); return; }
    rail.__upBusy = true;
    fetchCards(rail.getAttribute('data-u-src'), 1).then(function (res) {
      rail.__upBusy = false;
      rail.__upPool = res.cards;
      add(res.cards);
    }, function () { rail.__upBusy = false; rail.__upDone = true; });
  }
  function initRails() { [].forEach.call(D.querySelectorAll('[data-u-rail]'), topRail); }

  /* ---- the face (lens) ---- */
  function face() { return W.__mfFace ? (W.__mfFace() || '') : ''; }
  function paintLens() {
    var f = face();
    [].forEach.call(D.querySelectorAll('[data-u-lens] [data-u-face]'), function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-u-face') === f));
    });
  }
  function onFace() {
    paintLens();
    [].forEach.call(D.querySelectorAll('[data-u-more]'), function (m) { var l = m.__upList; if (l) { l.thinX = false; fill(l); } });
    initRails();
    revealMoods();
  }

  /* the marked mood keeps its place in the row (mockup); scroll the row so it is in view */
  function revealMood(row) {
    var on = row && row.querySelector('[aria-current="true"]');
    if (!on) { return; }
    var r = on.getBoundingClientRect(), m = row.getBoundingClientRect();
    if (r.left >= m.left && r.right <= m.right) { return; }
    row.scrollLeft += (r.left - m.left) - (m.width - r.width) / 2;
  }
  function revealMoods() { [].forEach.call(D.querySelectorAll('[data-u-coll] .u-moodc'), revealMood); }
  D.addEventListener('mf:face-changed', function (e) {
    if (e && e.detail && e.detail.source === 'clist') { return; }   /* ours: already handled */
    onFace();
  });

  /* ---- the collection: in-place re-render ---- */
  var renderToken = 0;
  var lastUrl = location.pathname + location.search;   /* the address the collection on screen was rendered for */
  function sectionUrl(url, id) {
    var u = new URL(url, location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('letter');   /* the section does not depend on it; up-lists filters */
    u.searchParams.set('section_id', id);
    return u.pathname + u.search;
  }
  function rerender(coll, url, push) {
    var id = coll.getAttribute('data-section-id');
    var token = ++renderToken;
    coll.classList.add('u-loading');
    if (push) { try { history.pushState({ upColl: id }, '', url); } catch (e) { location.href = url; return; } }
    lastUrl = location.pathname + location.search;
    fetch(sectionUrl(url, id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
      .then(function (html) {
        if (token !== renderToken) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-u-coll]');
        if (!fresh) { throw new Error('no section'); }
        var moodScroll = 0, oldMood = coll.querySelector('.u-moodc');
        if (oldMood) { moodScroll = oldMood.scrollLeft; }
        var node = D.importNode(fresh, true);
        if (rankOf(node)) { node.setAttribute('data-u-rank-wait', ''); }   /* no inline script runs here: hide as it would */
        coll.parentNode.replaceChild(node, coll);
        var mood = node.querySelector('.u-moodc');
        if (mood) { mood.scrollLeft = moodScroll; revealMood(mood); }
        paintLens();
        initGrids(node);
        paintAllLinks();
        /* keep the bar where the shopper is: back to the top of the grid if they were past it */
        var bar = node.querySelector('.u-prot');
        if (bar) {
          var gridTop = node.querySelector('[data-u-grid]');
          var y = gridTop ? gridTop.getBoundingClientRect().top + W.pageYOffset - bar.offsetHeight - (parseFloat(getComputedStyle(bar).top) || 0) : 0;
          if (W.pageYOffset > y) { W.scrollTo(0, Math.max(0, y)); }
        }
      })
      .catch(function () { if (token === renderToken) { location.href = url; } });
  }
  function urlWith(coll, mutate, path) {
    var params = new URLSearchParams(location.search);
    params.delete('page');
    params.delete('section_id');
    params.delete('view');
    mutate(params);
    var qs = params.toString();
    return (path || location.pathname) + (qs ? '?' + qs : '');
  }
  /* back / forward between the bar's states; a fragment link (#main, the skip link) changes no list - nothing to do */
  W.addEventListener('popstate', function () {
    var coll = D.querySelector('[data-u-coll]');
    if (!coll || location.pathname + location.search === lastUrl) { return; }
    rerender(coll, location.href, false);
  });

  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }

    var mb = t.closest('[data-u-more-btn]');
    if (mb) {
      var m = mb.closest('[data-u-more]');
      var l = m && (m.__upList || initGrid(m));
      if (l) { l.failed = false; l.target = visibleCount(l.grid) + l.per; step(l.stepName); fill(l); }
      return;
    }

    var th = t.closest('[data-u-thin]');
    if (th) {
      var tl = null;
      [].forEach.call(D.querySelectorAll('[data-u-more]'), function (m2) { if (m2.__upList && m2.__upList.thin && m2.__upList.thin.contains(th)) { tl = m2.__upList; } });
      if (th.getAttribute('data-u-thin') === 'x') { if (tl) { tl.thinX = true; dropThin(tl); } return; }
      /* live: the drawer tab's mnu:g_off, then the strip's own */
      step('mnu:g_off');
      step('mnu:g_offstrip');
      if (W.__mfSetFace) { W.__mfSetFace(''); }
      try { D.dispatchEvent(new CustomEvent('mf:face-changed', { detail: { face: '', source: 'clist' } })); } catch (eT) {}
      onFace();
      return;
    }

    /* a pick in the device sheet the heading opened: assets/up-menu.js builds the row's href (sort and every storefront
       filter travel, the Monogram view's tags among them) and sends cbar:dev_go, as live. It takes the row's
       mfd__devitem class off for this one click (mf-device's capture must not save it twice), so the row is matched
       by its data-href0 here. What it does not carry is added: the Monogram letter, so the new phone's view opens on
       the same letter. (Before 2026-10-21 this branch matched a.mfd__devitem and never ran; its step stays up-menu's.) */
    var di = t.closest('#devices a[data-href0]');
    if (di) {
      if (devFromColl && D.querySelector('[data-u-coll]') && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) {
        try {
          var cur = new URLSearchParams(location.search), u = new URL(di.getAttribute('href'), location.href), moved = false;
          cur.forEach(function (val, k) { if ((k.indexOf('filter.v.option.') === 0 || k === 'letter') && !u.searchParams.has(k)) { u.searchParams.append(k, val); moved = true; } });
          if (moved) { di.setAttribute('href', u.pathname + u.search); }
        } catch (eU) {}
      }
      return;
    }

    /* the Monogram sheet's "Vezi toate monogramele" for this very page's path (the pill's sheet, or the menu's on a
       phone's page): the view re-renders in place, the sheet closes (mono:all is the sheet's own step) */
    var mall = t.closest('#mono a[data-mfm-all]');
    if (mall) {
      var mc = D.querySelector('[data-u-coll]');
      if (mc && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) {
        try {
          var mu = new URL(mall.getAttribute('href'), location.href);
          if (mu.origin === location.origin && mu.pathname === location.pathname) {
            e.preventDefault();
            if (W.upPanel) { W.upPanel.close(); }
            rerender(mc, mu.pathname + mu.search, true);
          }
        } catch (eM) {}
      }
      return;
    }

    var coll = t.closest('[data-u-coll]');
    if (!coll) { return; }

    /* the Monogram pill: off the view the sheet, on it the way out of the view */
    var mp = t.closest('[data-u-mono-pill]');
    if (mp) {
      if (mp.getAttribute('data-u-mono-pill') === 'off') {
        var tags = mp.getAttribute('data-mono-tags') || '|';
        step('cbar:view_all');
        rerender(coll, urlWith(coll, function (p) {
          var keep = p.getAll('filter.p.tag').filter(function (v) { return tags.indexOf('|' + tagHandle(v) + '|') < 0; });
          p.delete('filter.p.tag');
          keep.forEach(function (v) { p.append('filter.p.tag', v); });
          p.delete('letter');
        }, tags === '|' ? coll.getAttribute('data-base') : null), true);
        return;
      }
      step('cbar:view_' + (mp.getAttribute('data-mono-key') || 'monogram'));
      if (W.mfOpenMonogram) {
        /* the opener up.js hands the focus back to (a tapped button keeps no focus on iOS) */
        try { mp.focus({ preventScroll: true }); } catch (eP) {}
        W.mfOpenMonogram({ base: mp.getAttribute('data-mono-base') || '' });
      } else {
        location.href = mp.getAttribute('data-href') || location.href;
      }
      return;
    }

    /* a letter of the Monogram view: a second tap on the pressed one clears it, as does the empty state's
       "Vezi toate literele" (data-u-letter="", which then hands the focus to the row) */
    var lb = t.closest('[data-u-letter]');
    if (lb) {
      var lm = coll.querySelector('[data-u-more]'), ll = lm && (lm.__upList || initGrid(lm));
      if (!ll || !ll.letters || lb.disabled) { return; }
      var lv = lb.getAttribute('data-u-letter') || '';
      setLetter(ll, lv === ll.letter ? '' : lv, 'pick');
      if (!ll.letters.contains(lb)) {
        var lf = ll.letters.querySelector('[data-u-letter]:not([hidden])');
        if (lf) { try { lf.focus({ preventScroll: true }); } catch (eL) {} }
      }
      return;
    }

    var st = t.closest('[data-u-step]');
    if (st && !t.closest('[data-u-more]')) { step('cbar:' + st.getAttribute('data-u-step')); }

    var fb = t.closest('[data-u-face]');
    if (fb) {
      var v = fb.getAttribute('data-u-face') || '';
      if (W.__mfSetFace) { W.__mfSetFace(v); }
      step('cbar:' + (v ? 'g_' + v : 'g_all'));
      try { D.dispatchEvent(new CustomEvent('mf:face-changed', { detail: { face: v, source: 'clist' } })); } catch (eF) {}
      onFace();
      return;
    }

    var tb = t.closest('[data-u-type]');
    if (tb) {
      var on = tb.getAttribute('aria-pressed') === 'true';
      var pn = tb.getAttribute('data-param'), pv = tb.getAttribute('data-value');
      step('cbar:type_' + (on ? 'off' : tb.getAttribute('data-u-type')));
      [].forEach.call(coll.querySelectorAll('[data-u-type]'), function (x) { x.setAttribute('aria-pressed', String(!on && x === tb)); });
      /* a chip may carry a second filter (glossy on: Full-Shock = case type Real-Material + tag Glossy): every chip's
         second value comes out, only that value - the Monogram tags on the same parameter stay */
      var p2 = [];
      [].forEach.call(coll.querySelectorAll('[data-u-type][data-param2]'), function (x) { p2.push([x.getAttribute('data-param2'), x.getAttribute('data-value2')]); });
      rerender(coll, urlWith(coll, function (p) {
        p.delete(pn);
        p2.forEach(function (q) { var keep = p.getAll(q[0]).filter(function (v) { return v !== q[1]; }); p.delete(q[0]); keep.forEach(function (v) { p.append(q[0], v); }); });
        if (!on) { p.append(pn, pv); if (tb.hasAttribute('data-param2')) { p.append(tb.getAttribute('data-param2'), tb.getAttribute('data-value2')); } }
      }), true);
      return;
    }

    var ma = t.closest('a[data-u-mood]');
    if (ma && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) {
      var key = ma.getAttribute('data-u-mood');
      var was = ma.getAttribute('aria-current') === 'true';
      step('cbar:' + (was ? 'mood_off' : 'mood_' + key));
      if (coll.hasAttribute('data-mood-page')) {
        /* a mood collection: the moods are collections - go there; off = the visitor's phone */
        if (was) { try { var dc = W.mfDeviceCollection && W.mfDeviceCollection(); if (dc) { e.preventDefault(); location.href = href(dc); } } catch (eD) {} }
        return;
      }
      e.preventDefault();
      var base = coll.getAttribute('data-base') || '';
      [].forEach.call(coll.querySelectorAll('a[data-u-mood]'), function (x) { if (x === ma && !was) { x.setAttribute('aria-current', 'true'); } else { x.removeAttribute('aria-current'); } });
      rerender(coll, urlWith(coll, function () {}, base + (was ? '' : '/' + key)), true);
    }
  });

  D.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-u-sort]') : null;
    if (!sel) { return; }
    var coll = sel.closest('[data-u-coll]');
    if (!coll) { return; }
    var v = sel.value;
    step('cbar:' + (v === 'created-descending' ? 'view_new' : v === 'best-selling' ? 'view_best' : 'view_all'));
    rerender(coll, urlWith(coll, function (p) { if (v) { p.set('sort_by', v); } else { p.delete('sort_by'); } }), true);
  });

  /* a tag as Shopify's handle (the server's handleize): the Monogram view's tags are compared that way */
  function tagHandle(v) {
    v = String(v || '').toLowerCase();
    try { v = v.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return v.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  /* the pill says whether the sheet it opens is up (whoever opened it) */
  function monoExpanded(on) {
    [].forEach.call(D.querySelectorAll('[data-u-mono-pill="open"]'), function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  D.addEventListener('u:panel-open', function (e) { if (e.detail && e.detail.id === 'mono') { monoExpanded(true); } });
  D.addEventListener('u:panel-close', function (e) { if (e.detail && e.detail.id === 'mono') { monoExpanded(false); } });

  /* ---- capture phase: where the device sheet was opened from; the card pin (mf-device.js 1d contract) ---- */
  var devFromColl = false;
  D.documentElement.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var op = t.closest('[data-u-open="devices"]');
    if (op) { devFromColl = !!op.closest('[data-u-coll]'); return; }
    var a = t.closest('a.u-card[href]');
    if (!a || !a.closest('[data-u-grid], [data-u-rail]')) { return; }
    var hm = /^\/products\/([^\/?#]+)/.exec(W.mfPath ? W.mfPath(a.pathname || '') : (a.pathname || ''));
    if (!hm) { return; }
    try { W.sessionStorage.setItem('mf_cardpin', JSON.stringify({ h: decodeURIComponent(hm[1]), t: new Date().getTime() })); } catch (eS) {}
    if (a.closest('[data-u-coll] [data-u-grid]')) { rkClick(a); }
  }, true);

  /* the empty state of an unfiltered collection: "all designs" = the visitor's phone when it is remembered */
  function paintAllLinks() {
    var dc = '';
    try { dc = W.mfDeviceCollection ? W.mfDeviceCollection() : ''; } catch (e) { dc = ''; }
    if (!dc || dc.split('?')[0] === location.pathname) { return; }
    [].forEach.call(D.querySelectorAll('[data-u-alldev]'), function (a) { a.setAttribute('href', dc); });
  }

  /* ---- the search page: the remembered phone in the eyebrow ---- */
  function paintDevice() {
    var label = '';
    try {
      var o = JSON.parse(localStorage.getItem('mf_dev1') || 'null');
      if (o && o.v === 1 && o.l && o.t && (new Date().getTime() - o.t) < 15552000000) { label = String(o.l).trim(); }
    } catch (e) {}
    if (!label) { return; }
    [].forEach.call(D.querySelectorAll('[data-u-srch] [data-u-devname]'), function (x) { x.textContent = label; });
    [].forEach.call(D.querySelectorAll('[data-u-srch] [data-u-devlabel]'), function (x) { x.hidden = false; });
  }

  function boot() {
    paintLens();
    initGrids();
    initRails();
    paintDevice();
    paintAllLinks();
    revealMoods();
  }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  D.addEventListener('shopify:section:load', function () { boot(); });
})();
